import { FunctionComponent } from 'react'
import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { Text } from '@conexasaude/conexa-hero'
import { useStyles } from './styles'

const AttendanceLate: FunctionComponent = () => {
  const { closeModal } = useModalContext()
  const styles = useStyles()

  return (
    <Modal
      id="ATTENDANCE_LATE"
      primaryAction={closeModal}
      primaryActionLabel="Ok, entendi"
    >
      <Text css={styles.informativeText}>
        Sua consulta já vai começar. O profissional de saúde está se preparando
        para iniciar o atendimento.
      </Text>
    </Modal>
  )
}

export default AttendanceLate
